import React, { useState } from "react"
import axios from "axios"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"

const GroupList = ({
  data,
  i,
  counter,
  getAllGroups,
  setSelectedGroup,
  setmodal_standard,
  openAssignUsersModal,
}) => {
  const [deleting, setDeleting] = useState(false)

  const deleteGroup = id => {
    if (window.confirm("Are you sure you want to delete this group?")) {
      setDeleting(true)
      axios
        .delete(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/groups/${id}`,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          setDeleting(false)
          if (res.data.success) {
            toast.success("Group deleted successfully", {
              position: "top-center",
              autoClose: 3000,
            })
            getAllGroups()
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
            })
          }
        })
        .catch(err => {
          setDeleting(false)
          toast.error("Failed to delete group", {
            position: "top-center",
            autoClose: 5000,
          })
        })
    }
  }

  const editGroup = group => {
    setSelectedGroup(group)
    setmodal_standard(true)
  }

  const formatDate = dateString => {
    const date = new Date(dateString)
    return date.toLocaleDateString() + " " + date.toLocaleTimeString()
  }

  return (
    <tr>
      <td>{counter + i}</td>
      <td>{data.name}</td>
      <td>{data.description || "No description"}</td>
      <td>
        <span className="badge bg-info">{data.users_count || 0} users</span>
      </td>
      <td>{formatDate(data.created_at)}</td>
      <td>
        <div className="btn-group" role="group">
          <button
            className="btn btn-sm btn-info me-1"
            onClick={() => openAssignUsersModal(data)}
            title="Assign Users"
          >
            <i className="fa fa-users"></i>
          </button>
          <button
            className="btn btn-sm btn-warning me-1"
            onClick={() => editGroup(data)}
            title="Edit Group"
          >
            <i className="fa fa-edit"></i>
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => deleteGroup(data.id)}
            disabled={deleting}
            title="Delete Group"
          >
            {deleting ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <i className="fa fa-trash"></i>
            )}
          </button>
        </div>
      </td>
    </tr>
  )
}

export default GroupList
